<template>
  <div>
    <div class="mb-3">
      <h5 class="mb-1">Employee Documents</h5>
      <p class="text-sm text-muted mb-0">
        View and download employee-required documents.
      </p>
    </div>

    <div v-if="loading" class="text-center py-4 text-muted">
      Loading documents...
    </div>

    <div v-else-if="documents.length === 0" class="text-center py-4 text-muted">
      No resource documents available yet.
    </div>

    <div v-else class="row">
      <div
        v-for="doc in documents"
        :key="doc.id"
        class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
      >
        <DefaultInfoCard
          :title="doc.title"
          :description="doc.description"
          :value="doc.title"
          :content="null"
          :content_type="'application/pdf'"
          :filename="doc.title"
          :file_url="doc.file_path"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DefaultInfoCard from "@/examples/Cards/DefaultInfoCard.vue";
import axios from "axios";

export default {
  name: "employee-resource-documents-page",
  components: {
    DefaultInfoCard,
  },
  data() {
    return {
      documents: [],
      loading: false,
    };
  },
  methods: {
    async fetchEmployeeDocuments() {
      this.loading = true;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/employee-resource-documents`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        this.documents = Array.isArray(response.data)
          ? response.data
          : [];
      } catch (error) {
        console.error("Backend error:", error);
        this.documents = [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchEmployeeDocuments();
  },
};
</script>
